module.exports = __webpack_public_path__ + "static/media/hidratante.8099be29.pdf";